import DataTable from "react-data-table-component";
import CustomLoader from "../../Components/custom/CustomLoader";
import PaginationControl from "../../Components/custom/PaginationControl";
import SearchBar from "../../Components/custom/SearchBar";
import { useState } from "react";
import { useFetch, useMutate } from "../../hooks/queries";

const renderValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "object") {
    return "";
  }
  return value;
};

const round = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return null;
  }
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const middleSchoolColumns = [
  {
    id: "student",
    name: "Student",
    cell: (row) => renderValue(row.Student),
    sortable: true,
    wrap: false,
    style: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "400px",
    },
    width: "400px",
  },

  {
    id: "studentId",
    name: "Student eSIS ID",
    cell: (row) => renderValue(row["Student ID"]),
  },
  {
    id: "grade",
    name: "Grade",
    cell: (row) => renderValue(row.Grade),
    wrap: true,
    width: "150px",
  },
  {
    id: "section",
    name: "Section",
    cell: (row) => renderValue(row.Section),
    wrap: true,
    width: "150px",
  },
  {
    id: "schoolName",
    name: "School Name",
    cell: (row) => renderValue(row["School Name"]),
    wrap: true,
    width: "150px",
  },
  {
    id: "schoolId",
    name: "School Id",
    cell: (row) => renderValue(row["School Code"]),
    wrap: true,
    width: "150px",
  },
  {
    id: "subject",
    name: "Subject",
    cell: (row) => renderValue(row["Subject"]),
    wrap: false,
    style: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "300px",
    },
    width: "300px",
  },
  {
    id: 7,
    name: "Term 1 Continuous Assessment",
    cell: (row) => renderValue(row["Term 1 Continuous Assessment"]) || "-",
    center: true,
  },
  {
    id: 8,
    name: "Term 1 Summative Assessment",
    cell: (row) => renderValue(row["Term 1 Summative Assessment"]) || "-",
    center: true,
  },
  {
    id: 9,
    name: "Term 1 Final Exam",
    cell: (row) => renderValue(row["Term 1 Final Exam"]) || "-",
    center: true,
  },
  {
    id: 10,
    name: "Term 2 Continuous Assessment",
    cell: (row) => renderValue(row["Term 2 Continuous Assessment"]) || "-",
    center: true,
  },
  {
    id: 11,
    name: "Term 2 Summative Assessment",
    cell: (row) => renderValue(row["Term 2 Summative Assessment"]) || "-",
    center: true,
  },
  {
    id: 12,
    name: "Term 2 Final Exam",
    cell: (row) => renderValue(row["Term 2 Final Exam"]) || "-",
    center: true,
  },
  {
    id: 13,
    name: "Term 3 Continuous Assessment",
    cell: (row) => renderValue(row["Term 3 Continuous Assessment"]) || "-",
    center: true,
  },
  {
    id: 14,
    name: "Term 3 Summative Assessment",
    cell: (row) => renderValue(row["Term 3 Summative Assessment"]) || "-",
    center: true,
  },
  {
    id: 15,
    name: "Term 3 Final Exam",
    cell: (row) => renderValue(row["Term 3 Final Exam"]) || "-",
    center: true,
  },
  {
    id: 16,
    name: "Term 1 Continuous Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 1 Continuous Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 17,
    name: "Term 1 Summative Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 1 Summative Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 18,
    name: "Term 1 Final Exam Final Score",
    cell: (row) => renderValue(row["Term 1 Final Exam Final Score"]) || "-",
    center: true,
  },
  {
    id: 19,
    name: "Term 2 Continuous Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 2 Continuous Assessment Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 20,
    name: "Term 2 Summative Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 2 Summative Assessment Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 21,
    name: "Term 2 Final Exam Final Score",
    cell: (row) => renderValue(row["Term 2 Final Exam Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 22,
    name: "Term 3 Continuous Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 3 Continuous Assessment Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 23,
    name: "Term 3 Summative Assessment Final Score",
    cell: (row) =>
      renderValue(row["Term 3 Summative Assessment Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 24,
    name: "Term 3 Final Exam Final Score",
    cell: (row) => renderValue(row["Term 3 Final Exam Final Score"]) || "-",
    center: true,
    sortable: true,
  },
  {
    id: 25,
    name: "Final Score",
    cell: (row) => renderValue(round(row["Final Score"], 2)) || "-",
    center: true,
    sortable: true,
  },
];

const highSchoolColumns = [
  {
    id: "student",
    name: "Student",
    cell: (row) => renderValue(row.Student),
    sortable: true,
    wrap: false,
    style: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "400px",
    },
    width: "400px",
  },
  {
    id: "studentId",
    name: "Student eSIS ID",
    cell: (row) => renderValue(row["Student ID"]),
  },

  {
    id: "grade",
    name: "Grade",
    cell: (row) => renderValue(row.Grade),
    wrap: true,
    width: "150px",
  },
  {
    id: "section",
    name: "Section",
    cell: (row) => renderValue(row.Section),
    wrap: true,
    width: "150px",
  },
  // {
  {
    id: "schoolName",
    name: "School Name",
    cell: (row) => renderValue(row["School Name"]),
    wrap: true,
    width: "150px",
  },
  {
    id: "schoolId",
    name: "School Id",
    cell: (row) => renderValue(row["School Code"]),
    wrap: true,
    width: "150px",
  },
  {
    id: "subject",
    name: "Subject",
    cell: (row) => renderValue(row["Subject"]),
    wrap: true,
  },
  {
    id: 7,
    name: "Semester 1 Continuous Assessment",
    cell: (row) => renderValue(row["Semester 1 Continuous Assessment"]) || "-",
    center: true,
  },
  {
    id: 8,
    name: "Semester 1 Summative Assessment",
    cell: (row) => renderValue(row["Semester 1 Summative Assessment"]) || "-",
    center: true,
  },
  {
    id: 9,
    name: "Semester 1 Final Exam",
    cell: (row) => renderValue(row["Semester 1 Final Exam"]) || "-",
    center: true,
  },
  {
    id: 10,
    name: "Semester 2 Continuous Assessment",
    cell: (row) => renderValue(row["Semester 2 Continuous Assessment"]) || "-",
    center: true,
  },
  {
    id: 11,
    name: "Semester 2 Summative Assessment",
    cell: (row) => renderValue(row["Semester 2 Summative Assessment"]) || "-",
    center: true,
  },
  {
    id: 12,
    name: "Semester 2 Final Exam",
    cell: (row) => renderValue(row["Semester 2 Final Exam"]) || "-",
    center: true,
  },
  // {
  //   id: 13,
  //   name: "Semester 3 Continuous Assessment",
  //   cell: (row) => renderValue(row["Semester 3 Continuous Assessment"]) || "-",
  //   center: true,
  // },
  // {
  //   id: 14,
  //   name: "Semester 3 Summative Assessment",
  //   cell: (row) => renderValue(row["Semester 3 Summative Assessment"]) || "-",
  //   center: true,
  // },
  // {
  //   id: 15,
  //   name: "Semester 3 Final Exam",
  //   cell: (row) => renderValue(row["Semester 3 Final Exam"]) || "-",
  //   center: true,
  // },
  {
    id: 16,
    name: "Semester 1 Continuous Assessment Final Score",
    cell: (row) =>
      renderValue(row["Semester 1 Continuous Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 17,
    name: "Semester 1 Summative Assessment Final Score",
    cell: (row) =>
      renderValue(row["Semester 1 Summative Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 18,
    name: "Semester 1 Final Exam Final Score",
    cell: (row) => renderValue(row["Semester 1 Final Exam Final Score"]) || "-",
    center: true,
  },
  {
    id: 19,
    name: "Semester 2 Continuous Assessment Final Score",
    cell: (row) =>
      renderValue(row["Semester 2 Continuous Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 20,
    name: "Semester 2 Summative Assessment Final Score",
    cell: (row) =>
      renderValue(row["Semester 2 Summative Assessment Final Score"]) || "-",
    center: true,
  },
  {
    id: 21,
    name: "Semester 2 Final Exam Final Score",
    cell: (row) => renderValue(row["Semester 2 Final Exam Final Score"]) || "-",
    center: true,
  },
  // {
  //   id: 22,
  //   name: "Semester 3 Continuous Assessment Final Score",
  //   cell: (row) =>
  //     renderValue(row["Semester 3 Continuous Assessment Final Score"]) || "-",
  //   center: true,
  // },
  // {
  //   id: 23,
  //   name: "Semester 3 Summative Assessment Final Score",
  //   cell: (row) =>
  //     renderValue(row["Semester 3 Summative Assessment Final Score"]) || "-",
  //   center: true,
  // },
  // {
  //   id: 24,
  //   name: "Semester 3 Final Exam Final Score",
  //   cell: (row) => renderValue(row["Semester 3 Final Exam Final Score"]) || "-",
  //   center: true,
  // },
  {
    id: 25,
    name: "Final Score",
    cell: (row) => renderValue(round(row["Final Score"], 2)) || "-",
    center: true,
  },
];

const Gradebook = (props) => {
  const [showZone, setShowZone] = useState(0); // 0 = Middle, 1 = High
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const buildGradebookUrl = () => {
    return showZone === 0
      ? `${process.env.REACT_APP_API_URL}CanvasUsers/GetMiddleSchool`
      : `${process.env.REACT_APP_API_URL}CanvasUsers/GetHighSchool`;
  };

  const buildGradebookRequestBody = () => {
    return {
      searchText: searchText,
      pageNumber: page,
      pageSize: perPage,
      sortBy: sortBy,
      sortOrder: sortOrder,
    };
  };

  const gradebookUrl = buildGradebookUrl();

  const {
    data: gradebookResponse,
    isPending,
    isLoading,
    isFetching,
  } = useFetch({
    queryKey: [
      "gradebook",
      showZone,
      page,
      perPage,
      searchText,
      sortBy,
      sortOrder,
    ],
    url: gradebookUrl,
    method: "PATCH",
    data: buildGradebookRequestBody(),
  });

  let rows = [];
  let totalRows = 0;

  if (Array.isArray(gradebookResponse)) {
    rows = gradebookResponse;
    totalRows = gradebookResponse.length;
  } else if (gradebookResponse && Array.isArray(gradebookResponse.data)) {
    rows = gradebookResponse.data;
    totalRows = gradebookResponse.totalCount || gradebookResponse.data.length;
  }

  const isTableLoading = isPending || isLoading || isFetching;

  const handleSearch = (value) => {
    setSearchText(value);
    setPage(1);
  };

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const handleSort = (column, sortDirection) => {
    const columnFieldMap = {
      student: "Student",
      studentId: "StudentId",
      grade: "Grade",
      section: "Section",
      schoolName: "SchoolName",
      schoolId: "SchoolCode",
      subject: "Subject",
    };
    setSortBy(columnFieldMap[column.id]);
    setSortOrder(sortDirection);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  const handleZoneChange = (zone) => {
    setShowZone(zone);
    setPage(1);
    setPerPage(20);
    setSearchText("");
    setSortBy("");
    setSortOrder("asc");
  };

  const downloadStudentsFile = (data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, "Students.xlsx");
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "Students.xlsx");
      document.body.appendChild(link);
      link.download = "Students.xlsx";
      link.click();
      document.body.removeChild(link);
    }
  };

  const exportMiddleMutation = useMutate({
    mutationKey: ["gradebook-export-middle"],
    url: `${process.env.REACT_APP_API_URL}CanvasUsers/ExportTermsReport`,
    method: "GET",
    axiosConfig: {
      responseType: "arraybuffer",
    },
    onSuccess: (data) => {
      downloadStudentsFile(data);
    },
  });

  const exportHighMutation = useMutate({
    mutationKey: ["gradebook-export-high"],
    url: `${process.env.REACT_APP_API_URL}CanvasUsers/ExportSemesterReport`,
    method: "GET",
    axiosConfig: {
      responseType: "arraybuffer",
    },
    onSuccess: (data) => {
      downloadStudentsFile(data);
    },
  });

  const exportingMiddle =
    exportMiddleMutation.isPending || exportMiddleMutation.isLoading;
  const exportingHigh =
    exportHighMutation.isPending || exportHighMutation.isLoading;

  return (
    <div className="api-sync">
      <div className="container-fluid mt-10">
        <div className="row">
          <div className="col-md-2">
            <h2>Gradebook</h2>
          </div>
          <div className="col">
            <div className="row tabs">
              <div
                className={
                  showZone === 0
                    ? "col text-center btn btn-sm btn-light active"
                    : "col text-center btn btn-sm btn-light"
                }
                onClick={() => handleZoneChange(0)}
              >
                Middle School
              </div>
              <div
                className={
                  showZone === 1
                    ? "col text-center btn btn-sm btn-light active"
                    : "col text-center btn btn-sm btn-light"
                }
                onClick={() => handleZoneChange(1)}
              >
                High School
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <hr />
          </div>
        </div>

        <div className="row">
          {showZone === 1 ? (
            <div>
              {props.userPermissions.exportHighSchool && (
                <div className="w-100 d-flex justify-content-end">
                  <button
                    className="btn btn-sm w-auto cts-btn-primary-3"
                    onClick={() => exportHighMutation.mutate()}
                    disabled={exportingHigh}
                  >
                    {exportingHigh
                      ? "Exporting data ..."
                      : "Export High School"}
                  </button>
                </div>
              )}

              <div className="mt-3">
                <div className="mt-3">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">High School</h3>
                      {/* <div style={{ width: "300px" }}>
                        <SearchBar
                          value={searchText}
                          onSearch={handleSearch}
                          onClear={handleClearSearch}
                          placeholder="Search gradebook..."
                          debounceMs={500}
                          disabled={isTableLoading}
                        />
                      </div> */}
                    </div>
                    <DataTable
                      data={Array.isArray(rows) ? rows : []}
                      columns={highSchoolColumns}
                      progressPending={isTableLoading}
                      progressComponent={<CustomLoader />}
                      fixedHeader
                      fixedHeaderScrollHeight={"60vh"}
                      defaultSortFieldId={1}
                      dense
                      highlightOnHover
                      striped
                      onSort={handleSort}
                      sortServer
                    />
                    <PaginationControl
                      totalCount={totalRows}
                      currentPage={page}
                      pageSize={perPage}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePerRowsChange}
                      pageSizeOptions={[10, 20, 50, 100, 200]}
                      disabled={isTableLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              {props.userPermissions.exportMiddleSchool && (
                <div className="w-100 d-flex justify-content-end">
                  <button
                    className="btn btn-sm w-auto cts-btn-primary-3"
                    onClick={() => exportMiddleMutation.mutate()}
                    disabled={exportingMiddle}
                  >
                    {exportingMiddle
                      ? "Exporting data ..."
                      : "Export Middle School"}
                  </button>
                </div>
              )}

              <div className="mt-3">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Middle School</h3>
                    {/* <div style={{ width: "300px" }}>
                      <SearchBar
                        value={searchText}
                        onSearch={handleSearch}
                        onClear={handleClearSearch}
                        placeholder="Search gradebook..."
                        debounceMs={500}
                        disabled={isTableLoading}
                      />
                    </div> */}
                  </div>
                  <DataTable
                    data={Array.isArray(rows) ? rows : []}
                    columns={middleSchoolColumns}
                    progressPending={isTableLoading}
                    progressComponent={<CustomLoader />}
                    fixedHeader
                    fixedHeaderScrollHeight={"60vh"}
                    defaultSortFieldId={1}
                    dense
                    highlightOnHover
                    striped
                    onSort={handleSort}
                    sortServer
                  />
                  <PaginationControl
                    totalCount={totalRows}
                    currentPage={page}
                    pageSize={perPage}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePerRowsChange}
                    pageSizeOptions={[10, 20, 50, 100, 200]}
                    disabled={isTableLoading}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Gradebook;
